import { render, staticRenderFns } from "./DTFACreate.vue?vue&type=template&id=dc0ac3b0&"
import script from "./DTFACreate.vue?vue&type=script&lang=js&"
export * from "./DTFACreate.vue?vue&type=script&lang=js&"
import style0 from "./DTFACreate.vue?vue&type=style&index=0&id=dc0ac3b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports